export const messages = {
  ra: {
    action: {
      add: "Agregar",
      delete: "Eliminar",
      show: "Mostrar",
      list: "Lista",
      save: "Guardar",
      create: "Crear",
      edit: "Editar",
      export: "Exportar",
      cancel: "Cancelar",
      refresh: "Refrescar",
      filter: "Filtrar",
      clear_input_value: "Limpiar",
      clear_array_input: "Limpiar lista",
      close: "Cerrar",
      open_menu: "Abrir menú",
      toggle_navigation: "Alternar navegación",
      undo: "Deshacer",
      add_filter: "Agregar filtro",
      clear_filters: "Limpiar filtros",
      sort: "Ordenar",
      confirm: "Confirmar",
      unselect: "Deseleccionar",
      toggle_theme: "Alternar tema",
      back: "Volver",
      remove_filter: "Quitar filtro",
      move_up: "Mover arriba",
      move_down: "Mover abajo",
      remove: "Eliminar",
      upload: "Subir",
      bulk_actions: "Acción para registros seleccionados",
    },
    menu: {
      profile: "Perfil",
    },
    navigation: {
      no_results: "Sin resultados",
      page_range_info: "%{offsetBegin} - %{offsetEnd} de %{total}",
      next: "Siguiente",
      previous: "Anterior",
      no_results_with_current_filters:
        "No se encontraron resultados con los filtros actuales",
      page_rows_per_page: "Filas por página",
    },
    sort: {
      ASC: "Ascendente",
      DESC: "Descendente",
    },
    configurable: {
      customize: "Personalizar",
    },
    page: {
      edit: "Editar %{name}",
      create: "Crear %{name}",
      list: "Lista de %{name}",
      show: "Mostrar %{name}",
      dashboard: "Panel de Control",
      not_found: "No encontrado",
      loading: "Cargando",
      error: "Se ha producido un error",
      empty: "No hay %{name} aún.",
      invite: "¿Desea agregar uno?",
    },
    message: {
      error: "Error",
      loading: "Será redirigido en unos segundos...",
      invalid_form:
        "El formulario no es válido. Por favor, revise los errores.",
      no_results_with_current_filters:
        "No se encontraron resultados con los filtros actuales",
      clear_array_input:
        "¿Está seguro de que desea eliminar todos los elementos?",
      item_doesnt_exist: "El elemento no existe",
    },
    validation: {
      required: "Este campo es obligatorio",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "Debe tener %{max} caracteres o menos",
    },
    notification: {
      updated: "Elemento actualizado",
      created: "Elemento creado",
      deleted: "Elemento eliminado",
    },
    auth: {
      auth_check_error: "Por favor, inicie sesión.",
    },
  },

  resources: {
    clients: {
      search: {
        name: "Buscar nombre",
      },
      title: "Clietes",
      name: "Cliente |||| Clientes",
      fields: {
        id: "ID",
        cuit: "DNI/CUIT",
        name: "Razón Social",
        email: "E-mail",
        phone: "Teléfono",
        status: "Estado",
      },
    },
    categories: {
      search: {
        name: "Buscar nombre",
      },
      title: "Categorías",
      name: "Categoría |||| Categorías",
      fields: {
        id: "ID",
        name: "Nombre",
        parent: {
          name: "Categoría padre",
        },
        featured: "Destacada",
        enabled: "Habilitado",
      },
    },
    ecowincooffices: {
      search: {
        name: "Buscar nombre",
      },
      title: "Puntos de venta EcoWinco",
      name: "Puntos de venta Ecowinco",
      fields: {
        id: "ID",
        name: "Nombre",
        province: "Provincia",
        city: "Ciudad",
        address: "Dirección",
        phone: "Teléfono",
        manager: "Contacto",
      },
    },
    products: {
      search: {
        name: "Buscar nombre",
      },
      title: "Productos",
      name: "Producto |||| Productos",
      tabs: {
        general: "General",
        images: "Imágenes",
        manual: "Manual",
        hdImages: "Imágenes HD",
        catalogImages: "imágenes catálogo",
      },
      fields: {
        id: "ID",
        code: "Código",
        name: "Nombre",
        category: "Categoría",
        price: "Precio",
        description: "Descripción",
        catalogDescription: "Descripción del Catálogo",
        quantityPerPackage: "Cantidad por bulto",
        featured: "Destacado",
        featuredLink: "Link Destacado",
        enabled: "Habilitado",
        stock: "Stock",
        minMediumStock: "Stock medio (Mínimo)",
        minHighStock: "Stock alto (Mínimo)",
        videoLink: "Link del video",
        featuredVideo: "Video Destacado",
      },
    },
    servicerequests: {
      search: {
        name: "Buscar nombre",
      },
      title: "Pedidos de Servicio Técnico",
      name: "Pedido de Servicio Técnico |||| Pedidos de Servicio Técnico",
      tabs: {
        general: "General",
      },
      fields: {
        id: "ID",
        status: "Estado",
        product: "Producto",
        dateFrom: "Desde fecha de alta",
        dateTo: "Hasta fecha de alta",
        productStatus: "Estado del Producto",
        shortProductStatus: "Est. prod.",
        purchaseDate: "Fecha de Compra",
        purchaseDateColumn: "F. Compra",
        invoiceImage:
          "Foto de la factura (Obligatorio, adjuntar para considerar la garantía)",
        needsSpareParts: "¿Requiere repuestos?",
        sparePartsDetail: "Repuestos",
        comments: "Observaciones",
        shortComments: "Obs",
        service: "Service",
        createdAt: "F. Alta",
        invoiceImageLink: "Factura",
        "service.name": "Service",
        clientFirstName: "Nombre del cliente",
        clientLastName: "Apellido del cliente",
        clientEmail: "Email del cliente",
        shortClientEmail: "Email cl.",
      },
    },
    services: {
      search: {
        name: "Buscar nombre",
      },
      title: "Servicio Técnico",
      name: "Servicio Técnico |||| Servicio Técnico",
      tabs: {
        general: "General",
      },
      fields: {
        id: "ID",
        createdAt: "F. Alta",
        active: "Activo",
        province: "Provincia",
        city: "Ciudad",
        name: "Nombre",
        address: "Dirección",
        phone: "Teléfono",
      },
    },
    sellers: {
      search: {
        name: "Buscar nombre",
      },
      title: "Puntos de Venta",
      name: "Puntos de Venta |||| Puntos de Venta",
      fields: {
        id: "ID",
        active: "Activo",
        name: "Nombre",
        webSite: "Sitio Web",
        position: "Orden",
      },
    },
    extendedwarranty: {
      search: {
        name: "Garantía extendida",
      },
      title: "Garantía extendida",
      name: "Garantía extendida |||| Garantía extendida",
    },
    articles: {
      name: "Noticia |||| Noticias",
      create: "Crear Noticia",
      edit: "Editar Noticia",
      empty: "No hay noticias aún",
      invite: "¿Deseas crear una?",
      fields: {
        id: "ID",
        title: "Título",
        content: "Contenido",
        slug: "Slug",
        image: "Imagen Principal",
        publishedAt: "Fecha de Publicación",
        readingTime: "Tiempo de Lectura",
        active: "Activo",
        createdAt: "Creado",
        updatedAt: "Actualizado",
      },
      actions: {
        create: "Crear noticia",
        edit: "Editar noticia",
        list: "Noticias",
        export: "Exportar noticias",
      },
      notifications: {
        created: "Noticia creada exitosamente",
        updated: "Noticia actualizada exitosamente",
        deleted: "Noticia eliminada",
      },
    },
    banners: {
      name: "Banner |||| Banners",
      create: "Crear Banner",
      edit: "Editar Banner",
      empty: "No hay banners aún",
      invite: "¿Deseas crear uno?",
      fields: {
        id: "ID",
        name: "Nombre",
        link: "URL de destino",
        image: "Imagen",
        page: "Página",
        position: "Posición",
        active: "Activo",
        created_at: "Fecha de Creación",
        updated_at: "Fecha de Actualización",
      },
      pages: {
        sellers: "Distribuidores",
        service: "Servicio técnico",
        blog: "Blog",
        contact: "Contacto",
      },
      actions: {
        create: "Crear banner",
        edit: "Editar banner",
        list: "Banners",
        export: "Exportar banners",
      },
      notifications: {
        created: "Banner creado exitosamente",
        updated: "Banner actualizado exitosamente",
        deleted: "Banner eliminado",
      },
    },
  },
};

export default messages;
